{
  "deselectedItem": "{item} غير المحدد",
  "select": "تحديد",
  "selectedAll": "جميع العناصر المحددة.",
  "selectedCount": "{count, plural, =0 {لم يتم تحديد عناصر} one {# عنصر محدد} other {# عنصر محدد}}.",
  "selectedItem": "{item} المحدد"
}
